import { MEDIA_SERVERS } from "@pdfking/constants/settings"

export default (path?: null | string): string[] =>
  MEDIA_SERVERS.map((prefix: string) => `${prefix}${path || ""}`)
